import restCrudActions from '../../../np-crud/store/restCrudActions';
import { getAxiosInstance } from '../../../np-rest/rest';
import config from '../../../../config/config';
import moment from 'moment';
import { snackActions } from '../../../sc-utilities/SnackBar';
import * as actionDownload from '../../../sc-downloadAll/store/downloadActions';
import { downloadFile } from '../../../sc-utilities';
import { socket } from '../../../../index';
import { download } from '../../../sc-utilities/download.utils';
import * as snackbarActions from '../../../sc-utilities/snackbar/store/snackbarActions';
import { WORKPLACE } from "../../../sc-utilities/snackbar/store/actionTypes";
import snackbarStore from "../../../../snackbarStore";


// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/pcProduct',
    pluginName: 'PRODUCT',
    entityName: 'PC_PRODUCT',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    lazyLoad: true
});

// Fetch pc products action creators
export const fetchPCProductInit = () => {
    return crudActions.fetchInit();
};
export const fetchPCProductStart = () => {
    return crudActions.fetchStart();
};
export const fetchPCProductSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchPCProductFail = () => {
    return crudActions.fetchFail();
};
export const fetchPCProductCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        // dispatch(fetchPCProductInit());
        try {
            let countRes = await rest.post("/products/pcProduct/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    // dispatch(fetchPCProductSuccess(0, []));
                }
                return countRes.data.result.data
            }
            // dispatch(fetchPCProductFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch pc product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            // dispatch(fetchPCProductFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch pc product."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchPCProduct = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        // dispatch(fetchPCProductInit());
        try {
            let listRes = await rest.post("/products/pcProduct/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                // dispatch(fetchPCProductSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data.products
            }
            // dispatch(fetchPCProductFail());
            return []

        } catch (error) {
            // dispatch(fetchPCProductFail());
            return []

        }
    }
}

// Load pc product action creators
export const loadPCProductInit = () => {
    return crudActions.loadInit();
};
export const loadPCProductStart = () => {
    return crudActions.loadStart();
};
export const loadPCProductSuccess = loadedPCProduct => {
    return crudActions.loadSuccess(loadedPCProduct);
};
export const loadPCProductFail = error => {
    return crudActions.loadFail(error);
};

export const loadPCProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadPCProductStart());
        try {
            let res = await rest.post('products/pcProduct/load', params);
            if (res.data && res.data.succeeded) {
                dispatch(loadPCProductSuccess(res.data.result.data ?? false));

                return res.data.result.data;
            }
            dispatch(loadPCProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load pc product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot load pc product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(loadPCProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Create pc product action creators
export const createPCProductInit = () => {
    return crudActions.createInit();
};
export const createPCProductStart = () => {
    return crudActions.createStart();
};
export const createPCProductSuccess = createdPCProduct => {
    return crudActions.createSuccess(createdPCProduct);
};
export const createPCProductFail = error => {
    return crudActions.createFail(error);
};
export const createPCProduct = pcProduct => {
    return async dispatch => {
        await crudActions.create(dispatch, pcProduct);
    };
};

// Edit pc product action creators
export const editPCProductInit = () => {
    return crudActions.editInit();
};
export const editPCProductStart = () => {
    return crudActions.editStart();
};
export const editPCProductSuccess = editedPCProduct => {
    return crudActions.editSuccess(editedPCProduct);
};
export const editPCProductFail = error => {
    return crudActions.editFail(error);
};
export const editPCProduct = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editPCProductStart());
        try {
            let res = await rest.post('products/pcProduct/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated pc product.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editPCProductFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit pc product."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit pc product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editPCProductFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}
// Bulk delete pc products action creators
export const bulkDeletePCProductsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeletePCProductsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeletePCProductsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeletePCProductsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeletePCProducts = pcProducts => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, pcProducts);
    };
};

// Delete pc product action creators
export const deletePCProductInit = () => {
    return crudActions.deleteInit();
};
export const deletePCProductStart = () => {
    return crudActions.deleteStart();
};
export const deletePCProductSuccess = deletedPCProduct => {
    return crudActions.deleteSuccess(deletedPCProduct);
};
export const deletePCProductFail = error => {
    return crudActions.deleteFail(error);
};
export const deletePCProduct = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};

export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: `${grade.InternationalGrading} (${grade.Condition})` });
                }
                return grades;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}



export const updatePresets = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/update-presets', params, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                return { status: true };
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return { status: false };
            }

        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { status: false };
        }
    };
}

export const fetchOperatingSystems = (params, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/operating_systems/list', { listAll: true, ...params }, { cancelToken: options?.cancelToken?.token });
            if (res && res.canceled) {
                return [];
            }
            if (res.data && res.data.succeeded) {
                const operatingSystems = [];
                for (var os of res.data.result.data) {
                    operatingSystems.push({ value: os.OperatingSystemID, displayValue: `${os.Name}` });
                }
                return operatingSystems;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}
export const fetchErasureMethod = (params) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/customer-erasure-method/list', { listAll: true, formatForWEBUI: true, q: { Visible: [1] }, ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch securaze standards."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}


export const fetchGradingCategories = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/grading_category/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const gradingCategories = [];
                for (var category of res.data.result.data) {
                    gradingCategories.push({ value: category.GradingCategoryID, displayValue: category.Product });
                }
                return gradingCategories;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

export const fetchTypicalProblems = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical_problems/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                let typicalProblems = [];
                for (var tp of res.data.result.data) {
                    if (tp.GradingCategory && tp.GradingCategory.Product) {
                        tp.GradingCategory.Product = tp.GradingCategory.Product.replace('unknown', 'All');
                    }
                    typicalProblems.push({ value: tp.TypicalProblemID, label: `${tp.LongName}${tp.GradingCategory ? ` - ${tp.GradingCategory.Product}` : ''}` });
                }
                return typicalProblems;
            }
            return [];
        } catch (error) {
            return [];
        }
    };
}

// Custom functions
export const downloadRawData = (ProductID, customerID) => {
    let token = localStorage.getItem('SESSION');

    return async dispatch => {
        return fetch(`${config.backend_domain}:${config.backend_port}/products/get_raw_data?ProductID=${ProductID}&ActiveCustomerID=${customerID.ActiveCustomerID}&Token=${token}`, {
            method: "GET",
        }).then(async response => {
            let fileName = `${moment().valueOf()}.txt`;
            response.headers.forEach((value, key) => {
                if (key === 'filename') {
                    fileName = value;
                }
            })
            if (response.status === 200) {
                return { status: 200, blob: await response.blob(), fileName: fileName }
            }
            try {
                let responseText = await response.text();
                responseText = JSON.parse(responseText);
                return {
                    status: response.status,
                    message: responseText.message
                }
            } catch (error) {
                return {
                    status: response.status,
                    message: null
                }
            }
        });
    }
};

export const generateReport = (pcProduct, translations, ErasureReportType) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            pcProduct['SocketID'] = socket.id.split('#')[1];
            dispatch({ type: 'START_GENERATE' });
            snackActions.snackBar({
                message: translations['report_generation_started'] || `Report generation started.`,
                options: {
                    variant: 'success'
                }
            });
            let res = await rest.post('report/generate', pcProduct);
            if (res.data && res.data.succeeded) {
                const redisTopic = res.data.result.data.RedisTopic;
                socket.once(redisTopic, async msg => {
                    const { Message, Status, ErasureReportID } = msg;
                    if (Status !== 'generated') {
                        snackActions.snackBar({
                            message: Message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                            options: {
                                variant: 'error'
                            }
                        });
                        dispatch({ type: 'FINISH_GENERATE' });
                        return false;
                    }
                    const objUrl = `${config.backend_domain}:${config.backend_port}/report/download?ReportID=${ErasureReportID}&ErasureReportType=${ErasureReportType}&ActiveCustomerID=${pcProduct.ActiveCustomerID}`;
                    await download(objUrl);
                    snackActions.snackBar({
                        message: translations['report_generation_finished'] || `Report generation finished.`,
                        options: {
                            variant: 'success'
                        }
                    });
                    dispatch({ type: 'FINISH_GENERATE' });

                });
            } else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}


export const fetchPrinters = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/printers/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot fetch printers."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            return [];
        }
    };
}

export const generateBulkReports = (pcProducts, translations) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            console.log(socket.id);
            pcProducts['SocketID'] = socket.id.split('#')[1];;
            let res = await rest.post('products/pcProduct/bulk_generate_report', pcProducts);
            if (res.data.status === 200) {
                for (const redisTopic of res.data.result.data.RedisTopics) {

                    socket.once(`${redisTopic}|0`, () => {
                        snackActions.snackBar({
                            message: translations['generate_report_start'] || `Erasure report starting.`,
                            options: {
                                variant: 'info'
                            }
                        });

                        socket.once(`${redisTopic}|2`, async msg => {
                            if (msg.Message.name === 'ERROR') {
                                snackActions.snackBar({
                                    message: msg.Message?.data?.message ?? (translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`),
                                    options: {
                                        variant: 'error'
                                    }
                                });
                                return false;
                            }
                            const reportID = msg.Message.data;
                            const filename = msg.Message.name;

                            let file = await dispatch(actionDownload.downloadErasure(reportID, pcProducts.ActiveCustomerID, filename, translations));
                            if (file) {
                                downloadFile(file, filename);
                            }
                        });
                    });
                }
                return true;
            }
            else {
                snackActions.snackBar({
                    message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: translations['generate_report_fail'] || `Error: Report failed. Please contact administrator.`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    };
}

export const printLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/print_label', data);
            if (res.data.status === 200) {
                return res.data.status === 200;
            }
            else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}
// custom functions
export const isPrintedLabel = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/is-printed', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print product."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            return false;
        }
    };
}

export const fetchOrders = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('palettes/order/list', { ...id, listAll: true, formatForWEBUI: true, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}

export const fetchCollies = (id) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('colli/list', { listAll: true, formatForWEBUI: true, ...id, productChangePalette: true });
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;

            return response ? response : [];
        } catch (error) {
            return [];
        }
    }
}

export const bulkPrintLabels = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/pcProduct/bulk_print_label', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot print label."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        }
        catch (error) {
            return [];
        }
    }
}

export const moveToAnotherPalette = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/pcProduct/change_palette', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot change palette."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}

export const productEditable = data => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('products/editable', data);
            let response = res && res.data && res.data.result && res.data.result.data ? res.data.result.data : false;
            return response ? response : false;
        } catch (error) {
            return false;
        }
    }
}

export const setPCProduct = (data) => {
    return ({
        type: 'HANDLE_PC_PRODUCT',
        productPC: data
    });
}

export const unpairExternalPC = externalID => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/pcProduct/unpair', { ProductExternalInfoID: externalID.data, ActiveCustomerID: externalID.ActiveCustomerID });
            return res.data.status === 200;
        } catch (error) {
            return false;
        }
    };
}

export const unpairBulkExternalPC = externalIDs => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('products/pcProduct/bulk_unpair', { ProductExternalInfoIDs: externalIDs.data, ActiveCustomerID: externalIDs.ActiveCustomerID });
            return res.data.status === 200;
        } catch (error) {
            return false;
        }
    };
}

export const cleanState = (data) => {
    return ({
        type: 'CLEAN_STATE',
        baseboard: data
    });
}

export const downloadReport = (params) => {
    return async () => {
        const IDs = params.PCProductIDs;
        const ErasureReportType = params.ErasureReportType;
        try {
            snackbarStore.dispatch(snackbarActions.showType({ type: WORKPLACE, selectedNumber: IDs.length }));
            let token = localStorage.getItem('SESSION');

            for (const productID of IDs) {

                const objectURL = `${config.backend_domain}:${config.backend_port}/report/download?ProductID=${productID}&ErasureReportType=${ErasureReportType}&ActiveCustomerID=${params.ActiveCustomerID}&Token=${token}`;

                let filename = `securaze_report.pdf`;

                let response = await fetch(objectURL, { method: 'GET', headers: { 'Content-Type': 'application/pdf' } });
                if (response.status === 200) {
                    const contentDisposition = response.headers.get('Content-Disposition').split(';');
                    for (const item of contentDisposition) {
                        if (item.includes('filename')) {
                            filename = item.split('=')[1];
                        }
                    }
                    // Create blob link to download
                    const url = window.URL.createObjectURL(
                        new Blob([await response.blob()]),
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute(
                        'download',
                        filename,
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                } else {
                    snackActions.snackBar({
                        message: `File not found for one of selected files (${productID}).`,
                        options: {
                            variant: 'error'
                        }
                    });
                }
                snackbarStore.dispatch(snackbarActions.incrementCounter(WORKPLACE));
            }

        } catch (error) {
            console.log(error);
            snackActions.snackBar({
                message: `File not found.`,
                options: {
                    variant: 'error'
                }
            });
        }
        snackbarStore.dispatch(snackbarActions.resetSnackbarCounter(WORKPLACE));
    }
}

export const hardDelete = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/hard-delete', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot delete product."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}

export const sendExternalData = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/external-system-setting/send-product-data', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot send product data."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}

export const sendErasureReports = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/external-system-setting/send-erasure-reports', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                return res.data.status;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot send erasure reports."}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
        }
    };
}
